// extracted by mini-css-extract-plugin
export var chevronIcon = "_s4-1";
export var edgeToggle = "_s4-0";